const { ucfirst } = require('@/functions/strings');

const ucfirstFilter = function (input) {
    return (typeof input === 'string') ? ucfirst(input) : input;
};

module.exports = ucfirstFilter;
